import React, { useState, useContext } from "react";
import { Box, TextField, Button, Typography, Snackbar, Alert } from "@mui/material";
import { useMutation } from "@apollo/client";
import { REQUEST_RESET, RESET_PASSWORD, SEND_EMAIL_MUTATION } from "../../../graphql/mutations";
import { UserContext } from "../../../components/auth/auth-context";

const UserPageChangepassword = ({ error, setError }) => {
  const { providerUser } = useContext(UserContext);
  const email = providerUser.email;
  const [resetStep, setResetStep] = useState("request"); // "request" or "enter"
  const [resetToken, setResetToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [completed, setCompleted] = useState(false)
  const [requestReset] = useMutation(REQUEST_RESET);
  const [resetPassword] = useMutation(RESET_PASSWORD);
  const [sendEmail] = useMutation(SEND_EMAIL_MUTATION);

  const handleRequestResetToken = async (e) => {
    e.preventDefault();
    try {
      const response = await requestReset({ variables: { email } });
      const generatedResetToken = response.data.requestReset.resetToken;
      await sendEmail({
        variables: {
          to: email,
          subject: "Reset Token",
          text: `Your reset token is: ${generatedResetToken}`,
          html: `<p>Your reset token is: <strong>${generatedResetToken}</strong></p>`,
        },
      });
      alert("Reset token has been sent to your email");
      setResetStep("enter");
    } catch (err) {
      console.error(err);
      alert("An error occurred while requesting the reset token");
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    // Validating the new password and confirmation password match
    if (newPassword !== confirmNewPassword) {
      alert("Password and confirmation do not match");
      return;
    }

    try {
      await resetPassword({
        variables: {
          email: email,
          password: newPassword,
          resetToken: resetToken,
        },
      });
      alert("Your password has been reset");
      setCompleted(true)

    } catch (err) {
      console.error(err);
      alert("An error occurred while resetting the password");
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      {resetStep === "request" ? (
        <>
          <Typography variant="body1" sx={{ mb: 2 }}>
            To change your password, please request a reset token by clicking the button below.
          </Typography>
          <Button variant="contained" color="primary" onClick={handleRequestResetToken}>
            Request Reset Token
          </Button>
        </>
      ) : (
        <>
          <Typography variant="body1" sx={{ mb: 2 }}>
            Please check your email for the reset token, then enter the token along with your new password.
          </Typography>
          <TextField
            label="Reset Token"
            variant="outlined"
            fullWidth
            value={resetToken}
            onChange={(e) => setResetToken(e.target.value)}
            autoComplete="off"
            sx={{ mt: 2 }}
          />
          <TextField
            label="New Password"
            variant="outlined"
            type="password"
            fullWidth
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoComplete="new-password"
            sx={{ mt: 2 }}
          />
          <TextField
            label="Confirm New Password"
            variant="outlined"
            type="password"
            fullWidth
            value={confirmNewPassword}
            onChange={(e) => setConfirmNewPassword(e.target.value)}
            autoComplete="off"
            sx={{ mt: 2 }}
          />
          <Button variant="contained" color="primary" disabled={completed} onClick={handleResetPassword} sx={{ mt: 2 }}>
            Reset Password
          </Button>
          <Button variant="text" color="secondary" onClick={() => setResetStep("request")} sx={{ mt: 1 }}>
            Back
          </Button>
        </>
      )}
      <Snackbar open={error} autoHideDuration={6000} onClose={() => setError(false)}>
        <Alert severity="error">An error occurred!</Alert>
      </Snackbar>
    </Box>
  );
};

export default UserPageChangepassword;
